export const GET_ANNOUNCEMENTS = 'GET_ANNOUNCEMENTS';
export const getAnnouncements = () => ({
  type: GET_ANNOUNCEMENTS,
});

export const GET_ANNOUNCEMENTS_SUCCESS = 'GET_ANNOUNCEMENTS_SUCCESS';
export const getAnnouncementsSuccess = (announcements) => ({
  type: GET_ANNOUNCEMENTS_SUCCESS,
  announcements,
});
